import {
  designColors,
  designRadii,
  designShell,
  designWeights,
} from "services/constants/designTokens";

// Shared visual tokens for the Home dashboard so every tile/card reads as one
// system (matches the V2 dashboard design). Kept in one place so a palette or
// radius tweak is a single edit rather than a sweep across every card.
export const dashboard = {
  pageBg: designColors.pageBg,
  cardSx: {
    ...designShell.sectionCard,
    borderRadius: designRadii.card,
    p: 1.75,
    height: "100%",
  },
  // soft tinted circle behind a KPI icon
  iconWrap: (color) => ({
    width: 42,
    height: 42,
    borderRadius: 1.8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: `${color}1A`,
    color,
    flexShrink: 0,
  }),
  linkSx: {
    cursor: "pointer",
    color: designColors.tealDark,
    fontWeight: designWeights.semibold,
    fontSize: 13.5,
    "&:hover": { textDecoration: "underline" },
  },
  colors: {
    green: designColors.tealDark,
    blue: "#2563EB",
    purple: "#7C3AED",
    amber: "#D97706",
    text: designColors.slate900,
    subText: designColors.slate600,
  },
};
